import { AxiosMode } from '@/axiosModel';

export interface CommonUploadFileResponse {
  fileName?: string;
  fileSrc?: string;
}

const apis = new AxiosMode();
const COMMON_API_BASE = `${AxiosMode.API_HOST}/api/common`;
const AIPICTUREBOOK_API_BASE = `${AxiosMode.API_HOST}/api/aipicturebook`;

export const FILE_UPLOAD_ENDPOINT = `${COMMON_API_BASE}/upload-file`;
export const IMAGE_UPLOAD_ENDPOINT = `${AIPICTUREBOOK_API_BASE}/upload-image`;

export async function uploadFileResult(file: File): Promise<CommonUploadFileResponse> {
  const formData = new FormData();
  formData.append('file', file);

  const { req } = apis.post({
    postData: formData,
    remotePath: FILE_UPLOAD_ENDPOINT
  });
  const res = (await req) as { data?: CommonUploadFileResponse };

  return res.data ?? {};
}

export async function uploadFile(file: File): Promise<string> {
  const result = await uploadFileResult(file);
  const imageUrl = normalizeFileSrc(result.fileSrc);

  if (!imageUrl) throw new Error('文件上传失败，未返回地址');

  return imageUrl;
}

export async function uploadBlob(blob: Blob, fileName: string): Promise<string> {
  const file = new File([blob], fileName, { type: blob.type });
  return uploadFile(file);
}

export async function uploadImageFile(file: File): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);

  const { req } = apis.post({
    postData: formData,
    remotePath: IMAGE_UPLOAD_ENDPOINT
  });
  const res = (await req) as { data?: CommonUploadFileResponse };
  const imageUrl = normalizeFileSrc(res.data?.fileSrc);

  if (!imageUrl) throw new Error('图片上传失败，未返回图片地址');

  return imageUrl;
}

export function normalizeFileSrc(value: unknown) {
  const url = toStringValue(value).trim();
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;

  return `https://${url.replace(/^\/+/, '')}`;
}

function toStringValue(value: unknown) {
  return typeof value === 'string' ? value : '';
}
